import React from 'react';
import { Card, Skeleton, Grid } from 'antd';
import { useTheme } from '../../Shared/GlobalContext/ThemeContext';

const { useBreakpoint } = Grid;

const ChannelCardSkeleton = () => {
    const screens = useBreakpoint();
    const isMobile = screens?.xs;
    const { isDarkMode } = useTheme();

    const dividerColor = isDarkMode ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.06)';

    return (
        <Card
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: isMobile ? '100%' : '260px',
            }}
            bordered={false}
            styles={{
                body: {
                    padding: '24px',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }
            }}
            actions={[
                <Skeleton.Button active size="small" shape="circle" key="1" />,
                <Skeleton.Button active size="small" shape="circle" key="2" />,
                <Skeleton.Button active size="small" shape="circle" key="3" />
            ]}
        >
            {/* Header Section */}
            <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
                marginBottom: '24px'
            }}>
                <div style={{ display: 'flex', gap: '16px', flex: 1, minWidth: 0 }}>
                    {/* Avatar */}
                    <Skeleton.Avatar
                        active
                        size={52}
                        style={{
                            borderRadius: '50%',
                            flexShrink: 0
                        }}
                    />

                    <div style={{
                        display: 'flex', flexDirection: 'column', justifyContent: 'center', flex: 1, minWidth: 0,
                        overflowX: 'hidden'
                    }}>
                        {/* Channel name */}
                        <Skeleton.Input
                            active
                            style={{
                                width: '100%',
                                height: '22px',
                                marginBottom: '4px'
                            }}
                        />
                        {/* Channel type + category */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                            <Skeleton.Input
                                active
                                style={{
                                    width: '80px',
                                    height: '16px'
                                }}
                            />
                            <Skeleton.Input
                                active
                                style={{
                                    width: '60px',
                                    height: '16px',
                                    borderRadius: '4px'
                                }}
                            />
                        </div>
                        {/* Description */}
                        <Skeleton.Input
                            active
                            style={{
                                width: '100%',
                                height: '17px'
                            }}
                        />
                    </div>
                    <div style={{ marginLeft: '12px', flexShrink: 0 }}>
                        <Skeleton.Avatar
                            active
                            size={16}
                            shape="circle"
                        />
                    </div>
                </div>
            </div>

            {/* Agent Section */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                <Skeleton.Avatar
                    active
                    size={40}
                    style={{
                        borderRadius: '10px'
                    }}
                />
                <div style={{ flex: 1 }}>
                    <Skeleton.Input
                        active
                        style={{
                            width: '60px',
                            height: '12px',
                            marginBottom: '4px'
                        }}
                    />
                    <Skeleton.Input
                        active
                        style={{
                            width: '120px',
                            height: '16px'
                        }}
                    />
                </div>
            </div>

            <div style={{ height: '1px', background: dividerColor, marginBottom: '16px' }} />

            {/* Credential Section */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <Skeleton.Avatar
                    active
                    size={40}
                    style={{
                        borderRadius: '10px'
                    }}
                />
                <div style={{ flex: 1 }}>
                    <Skeleton.Input
                        active
                        style={{
                            width: '80px',
                            height: '12px',
                            marginBottom: '4px'
                        }}
                    />
                    <Skeleton.Input
                        active
                        style={{
                            width: '100px',
                            height: '16px'
                        }}
                    />
                </div>
            </div>
        </Card>
    );
};

export default ChannelCardSkeleton;
